import rescueReasons from "./rescueReasons.component";

const rescueReasonsModule = angular
  .module("app.components.rescueReasons", [])
  .component("rescueReasons", rescueReasons);

export default rescueReasonsModule;



// WEBPACK FOOTER //
// ./src/components/rescueReasons/rescueReasons.module.js